/** 自动提现用户 */
<template>
  <div class="home protocol-home">
    <Layout
      type="HOME"
      pageTitle="自动提现用户列表"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasiceLayout
        title="自动提现用户列表"
        class="bonus-code-layout"
      >
        <div class="margin-20 display-flex">
          <el-input
            v-model="searchEmail"
            placeholder="输入要搜索的账号"
            style="max-width: 200px"
          ></el-input>
          <div
            class="button"
            @click="search"
          >搜索</div>
        </div>
        <div class="margin-20 display-flex">
          <el-table
            v-if="showEmailList && showEmailList.length"
            :data="showEmailList"
            style="width: 100%"
          >
            <el-table-column
              prop="email"
              label="邮箱"
              width="180"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <div
                  class="red-button"
                  @click="deleteEmail(scope.row)"
                >删除</div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import Layout from "@/components/CRM/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";

export default {
  name: "home",
  data() {
    return {
      total: "",
      email: "",
      emailList: "",
      showEmailList: "",
      searchEmail: "",
    };
  },
  computed: mapState({}),
  components: {
    Layout,
    BasiceLayout,
  },
  methods: {
    ...mapActions(["getUserList", "setEmailToList", "setEmailAuth"]),
    addEmailToList() {
      let { email } = this;
      this.setEmailAuth({
        type: "black",
        email: email,
        action: "add",
      }).then((res) => {
        if (res.code === 200) {
          Message({
            type: 'success',
            message: "添加成功"
          });
        } else {
          Message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    search() {
      let { searchEmail, emailList } = this;
      // if (emailList.includes())
      let item = emailList.find((item) => item.email == searchEmail);
      if (item) {
        this.showEmailList = [item];
      } else {
        this.showEmailList = [];
      }
    },
    deleteEmail(item) {
      console.log(12);
      if (item.email) {
        this.setEmailAuth({
          type: "autoWithdrawal",
          email: item.email,
          action: "delete",
        }).then((res) => {
        if (res.code === 200) {
          Message({
            type: 'success',
            message: '删除成功'
          });
        } else {
          Message({
            type: "error",
            message: res.message,
          });
        }
      });
      }
    },
  },
  created() {
    this.getUserList({type: "autoWithdrawal"}).then(res => {
      this.emailList = res.data;
      this.showEmailList = res.data;
    });
  },
};
</script>

<style  lang="stylus">
.node-dial-content {
  width: 80%;
}

.crm-node-content {
  padding-top: 80px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  text-align: left;
}

.label-button {
  max-width: 100%;
}
</style>
